<template>
  <el-dialog
    class="widget-settings-dialog"
    :title="'Настройки элемента'"
    append-to-body
    :close-on-click-modal="false"
    :visible.sync="show"
    width="50%"
  >
    <div
      v-if="show"
    >
      <el-form
        size="mini"
        label-position="left"
        label-width="200px"
      >
        <el-form-item label="Название">
          <click-to-edit
            placeholder=""
            v-model="node.model.name"
            @input="updateNode"
          ></click-to-edit>
        </el-form-item>
        <el-form-item label="Описание">
          <click-to-edit
            placeholder=""
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6}"
            v-model="node.model.desc"
            @input="updateNode"
          ></click-to-edit>
        </el-form-item>
        <el-form-item label="Шкала">
          <click-to-edit
            v-model="node.model.scale_type"
            type="select"
            select-filterable
            :select-options="$cascadingConstants.scales.typesSelectOptions"
            placeholder=""
            @input="updateNode(node)"
          ></click-to-edit>
        </el-form-item>
        <el-form-item label="Измерение">
          <cascading-scale-unit-select
            v-model="node.model"
            @change="updateNode(node)"
          ></cascading-scale-unit-select>
        </el-form-item>

        <el-form-item label="Значения">
          <div style="display: flex; justify-content: space-between; gap: 20px">
            <div style="width:33%">
              Value
              <CascadingScalePerformanceValuesInput
                v-model="node.model"
                style="width: 100%"
                performance-value-name="value"
                @change="updateNode"
              ></CascadingScalePerformanceValuesInput>
            </div>
            <div style="width:33%">
              Baseline
              <CascadingScalePerformanceValuesInput
                v-model="node.model"
                style="width: 100%"
                performance-value-name="baseline"
                @change="updateNode"
              ></CascadingScalePerformanceValuesInput>
            </div>
            <div style="width:33%">
              Target
              <CascadingScalePerformanceValuesInput
                v-model="node.model"
                style="width: 100%"
                performance-value-name="target"
                @change="updateNode"
              ></CascadingScalePerformanceValuesInput>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Расширенный режим">
          <div style="display: flex; justify-content: space-between; gap: 20px">
            <div style="width:33%">
              <el-switch
                v-model="node.model.extended_performance_scale"
                :inactive-value="false"
                :active-value="true"
                @change="updateNode"
              >
              </el-switch>
            </div>
            <div style="width:33%" v-if="node.model.extended_performance_scale">
              Min
              <CascadingScalePerformanceValuesInput
                v-model="node.model"
                performance-value-name="min"
                @change="updateNode"
              ></CascadingScalePerformanceValuesInput>
            </div>
            <div style="width:33%" v-if="node.model.extended_performance_scale">
              Max
              <CascadingScalePerformanceValuesInput
                v-model="node.model"
                performance-value-name="max"
                @change="updateNode"
              ></CascadingScalePerformanceValuesInput>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Вес" v-if="node.thisParentLink">
          <click-to-edit
            placeholder=""
            digits-only
            v-model="node.thisParentLink.weight"
            @input="updateNodeParentLink(node.thisParentLink)"
          ></click-to-edit>
        </el-form-item>

        <el-form-item label="Функция расчета(если нет дочерних или ручной режим)">
          <PerformanceFormulaSelect
            v-model="node.model"
            @change="updateNode"
          ></PerformanceFormulaSelect>
        </el-form-item>

        <el-form-item label="Значение полей из дочерних">
          <click-to-edit
            v-model="node.model.child_values_aggregate_type"
            type="select"
            select-filterable
            :select-options="$cascadingConstants.elementChildValuesAggregate.typesSelectOptions"
            placeholder=""
            @input="updateNode(node)"
          ></click-to-edit>
        </el-form-item>
        <el-form-item label="Значение результата из дочерних">
          <click-to-edit
            v-model="node.model.child_performance_aggregate_type"
            type="select"
            select-filterable
            :select-options="$cascadingConstants.elementChildPerformanceAggregate.typesSelectOptions"
            placeholder=""
            @input="updateNode(node)"
          ></click-to-edit>
        </el-form-item>


        <el-form-item label="Результат">
          <div style="display: flex; gap: 20px">
            <div style="width:33%">
              performance: {{node.model.performance}}%
            </div>
            <div style="width:33%">
              progress: {{node.model.progress}}%
            </div>
          </div>
        </el-form-item>

        <el-form-item label=""></el-form-item>

        <el-form-item label="Шкала карты">
          <CascadingCardScaleSelect
            v-model="node.model"
            @change="updateNode"
          ></CascadingCardScaleSelect>
        </el-form-item>
        <el-form-item label="Вес в карте">
          <click-to-edit
            placeholder=""
            digits-only
            v-model="node.model.card_weight"
            @input="updateNode"
          ></click-to-edit>
        </el-form-item>
        <el-form-item label="Результат карты">
          <div style="display: flex; gap: 20px">
            <div style="width:33%">
              bonus: {{node.model.card_bonus}}%
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Назначить в карту">
          <div v-if="!node.model.auto_cascaded">
            <el-radio-group
              v-model="node.model.card_assign_type"
              @change="updateNode"
            >
              <el-radio-button :label="null">Не назначается</el-radio-button>
              <el-radio-button :label="1">Вручную</el-radio-button>
              <el-radio-button :label="2">КО</el-radio-button>
            </el-radio-group>

            <div v-if="node.model.card_assign_type === $cascadingConstants.elementCardAssign.types.TYPE_MANUAL">
              <cards-select-modal
                @card-selected="cardSelected"
              >
                <el-button
                  slot="reference"
                  size="small"
                  icon="far fa-trash-alt"
                >
                  Выбрать карту
                </el-button>
              </cards-select-modal>
              <el-button
                size="small"
                icon="far fa-trash-alt"
                @click="clearSelectedCard"
              >
                Удалить назначение
              </el-button>


            </div>
            <div v-if="node.model.card_assign_type === $cascadingConstants.elementCardAssign.types.TYPE_VQB">
              Конструктор отчетов позволяет запланировать назначение. Вы можете выбрать в какую карту должна будет быть назначена цель. А потом массово все такие цели назначить

              Цель будет добавлена в первую карту, попавшую под условия.
              Если необходимо добавить цель сразу в несколько карт - воспользуйтесь автоматическим каскадированием

              <entity-saved-report-form
                style="margin-top: -30px"
                :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_CASCADING_ELEMENT_CARD_ASSIGNMENTS"
                :entity-id="node.model.id"
                entity-report-key="cards"
                delete-on-empty-search
              ></entity-saved-report-form>

              <el-button
                size="small"
                icon="far fa-trash-alt"
                @click="assignNodeToCard(null)"
              >
                Пересчитать
              </el-button>
            </div>
          </div>
          <div v-else>Цель добавлена автоматическим каскадирвоанием</div>

          <div>
            <div v-if="node.model.card">
              {{cardAppointmentText}}
              <router-link
                target="_blank"
                :to="{ name: 'Card', params: { id: node.model.card_id } }"
              >
                <i class="fas fa-external-link-alt"></i>
              </router-link>

            </div>

            <div v-else>Не назначено в карту</div>
          </div>
        </el-form-item>


        <el-form-item label="Автоматическое каскадирование">
          <el-radio-group
            v-model="node.model.auto_cascading_type"
            @change="updateNode"
          >
            <el-radio-button :label="null">Не каскадируется</el-radio-button>
<!--            <el-radio-button :label="1">Вручную</el-radio-button>-->
            <el-radio-button :label="2">КО</el-radio-button>
          </el-radio-group>

          <div v-if="node.model.auto_cascading_type">
            <div>
              Распределение target
              <click-to-edit
                v-model="node.model.auto_cascading_target_partition_type"
                type="select"
                select-filterable
                :select-options="$cascadingConstants.elementAutoCascading.targetPartitionTypesSelectOptions"
                placeholder=""
                @input="updateNode(node)"
              ></click-to-edit>
            </div>
            <div>
              Вес в карте
              <click-to-edit
                v-model="node.model.auto_cascading_card_weight"
                digits-only
                placeholder=""
                @input="updateNode(node)"
              ></click-to-edit>
            </div>

          </div>



          <div v-if="node.model.auto_cascading_type === $cascadingConstants.elementAutoCascading.types.TYPE_VQB">
            Конструктор отчетов позволяет запланировать каскадирование. Вы можете выбрать в какие карты должна будет каскадироваться цель. А потом массово все такие цели назначить

            <entity-saved-report-form
              style="margin-top: -30px"
              :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_CASCADING_ELEMENT_AUTO_CASCADING"
              :entity-id="node.model.id"
              entity-report-key="cards"
              delete-on-empty-search
            ></entity-saved-report-form>

            <el-button
              size="small"
              icon="far fa-trash-alt"
              @click="runAutoCascading"
            >
              Каскадировать
            </el-button>
            <el-switch></el-switch>Автоматически создавать элементы при создании карт
          </div>

        </el-form-item>




      </el-form>


    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="show = false;">Закрыть</el-button>
    </span>
  </el-dialog>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingScalePerformanceValuesInput
  from "@/modules/cascading/components/scale/CascadingScalePerformanceValuesInput.vue";
import PerformanceFormulaSelect from "@/modules/cascading/components/PerformanceFormula/PerformanceFormulaSelect.vue";
import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";
import CascadingCardScaleSelect from "@/modules/cascading/components/cardScale/CascadingCardScaleSelect.vue";
import DeletedCardsModal from "@/components/cards/DeletedCardsModal.vue";
import CardsSelectModal from "@/components/cards/CardSelectModal.vue";
import EntitySavedReportForm from "@/components/report/builder/EntitySavedReportForm.vue";

export default {
  name: 'ElementsTreeNodeSettingsDialog',
  components: {
    EntitySavedReportForm,
    CardsSelectModal,
    DeletedCardsModal,
    CascadingCardScaleSelect,
    CascadingScaleUnitSelect, PerformanceFormulaSelect, CascadingScalePerformanceValuesInput, ClickToEdit},
  props: {},
  computed: {
    cardAppointmentText() {
      if( !this.node.model.card ){
        return 'Не назначено в карту';
      }
      return 'Назначено в карту ' + this.node.model.card.user.full_name + ' ' + this.node.model.card.year;
    }
  },
  data() {
    return {
      show: false,
      node: {},
    }
  },

  methods: {
    open(node){
      this.node = node;
      this.show = true;
    },
    updateNode(){
      this.$emit('update-node', this.node);
    },
    updateNodeParentLink(parentLink) {
      this.$emit('update-node-parent-link', {
        node: this.node,
        parentLink: parentLink
      });
    },

    assignNodeToCard(cardId){
      this.$emit('assign-node-to-card', {
        node: this.node,
        cardId: cardId
      });
    },
    cardSelected(card){
      this.assignNodeToCard(card.id);
    },
    clearSelectedCard(){
      this.assignNodeToCard(null);
    },


    runAutoCascading(){
      this.$emit('run-auto-cascading', {node: this.node});
    },
  }

}
</script>

<style lang="scss">
.widget-settings-dialog .el-tabs__content{
  overflow: unset;
}

.el-tabs__new-tab{
  width: 100px;

  &:after{
    content: 'Добавить';
  }
}

</style>